module.exports = __webpack_public_path__ + "static/img/mongo.bf2c0fe3.png";